module.exports = __webpack_public_path__ + "static/media/chat-bot-6.f3b2dfe7.jpg";